import React from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { useCheckbox } from '../checkbox/useCheckbox';
import { Tag } from '../tag/Tag';

const radioTagStyle = variant({
  key: 'radio.tag',
});

const StyledTag = styled(Tag)`
  ${radioTagStyle}
  transition: color 180ms, background-color 180ms;
`;

export const RadioTag = ({ checked, onChange, children, value, ...rest }) => {
  const { isChecked, handleChange } = useCheckbox({ checked, onChange });
  const handleClick = e => {
    e.target.value = value;
    handleChange(e);
  };

  return (
    <StyledTag onClick={handleClick} variant={isChecked ? 'active' : null} checked={isChecked} {...rest}>
      {children}
    </StyledTag>
  );
};
